export const tureIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 21.837 21.837"
  >
    <g id="Group_1" data-name="Group 1" transform="translate(-1193 132)">
      <path
        id="Path_1"
        data-name="Path 1"
        d="M3.979,11.089A3.978,3.978,0,0,0,0,15.068C0,17.889,3.979,21.5,3.979,21.5s3.979-3.612,3.979-6.437a3.978,3.978,0,0,0-3.979-3.979m0,5.861a1.99,1.99,0,1,1,1.99-1.99,1.99,1.99,0,0,1-1.99,1.99"
        transform="translate(1193 -132)"
        fill="#fff"
      />
      <path
        id="Path_2"
        data-name="Path 2"
        d="M17.272,0a3.978,3.978,0,0,0-3.979,3.979c0,2.821,3.979,6.437,3.979,6.437S21.251,6.8,21.251,3.979A3.978,3.978,0,0,0,17.272,0m0,5.861a1.99,1.99,0,1,1,1.99-1.99,1.99,1.99,0,0,1-1.99,1.99"
        transform="translate(1193 -132)"
        fill="#fff"
      />
      <path
        id="Path_3"
        data-name="Path 3"
        d="M21.837,18.8A3.036,3.036,0,0,1,18.8,21.837H4.607c.152-.146.384-.374.669-.673H18.8a2.36,2.36,0,1,0,0-4.72H13.2a3.182,3.182,0,0,1,0-6.364h2.773c.284.3.523.53.672.672H13.206a2.51,2.51,0,0,0,0,5.019h5.6A3.036,3.036,0,0,1,21.837,18.8"
        transform="translate(1193 -132)"
        fill="#fff"
      />
    </g>
  </svg>
);
